import { render, staticRenderFns } from "./pay_url_comp.vue?vue&type=template&id=66dbc60f&scoped=true"
import script from "./pay_url_comp.vue?vue&type=script&lang=js"
export * from "./pay_url_comp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66dbc60f",
  null
  
)

export default component.exports